import logoUrl from '@/assets/ramp-logo.svg'

/**
 * Full-pane branded loading state (logo + spinner), shown while auth resolves
 * and while the account's AI feature flag is being checked. Matches the login
 * screen's backdrop so the auth flow reads as one surface.
 */
export function LoadingScreen({ message = 'Loading…' }: { message?: string }) {
  return (
    <div className='ramp-loading' role='status'>
      <img className='ramp-loading-logo' src={logoUrl} alt='ramp' />
      <div className='ramp-loading-spinner' aria-hidden='true' />
      <p className='ramp-loading-text'>{message}</p>
    </div>
  )
}
